module.exports = __webpack_public_path__ + "static/media/bfrc-logo.d76c5ecf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bfrc-logo.svg
// module id = 378
// module chunks = 0